export const loginConstant = {
  mobile: {
    en: "Enter Phone Number",
    hi: "फ़ोन नंबर डालें",
    or: "ଫୋନ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
    mr: "फोन नंबर टाका"
  },
  pass: {
    en: "Enter the 6 digit OTP",
    hi: "6-डिजिट ओटीपी दर्ज करें",
    or: "6 ଅଙ୍କ ବିଶିଷ୍ଟ OTP",
    mr : "6 अंकी HealthVaani कोड टाका"
  },
  support:{
    en:"Call for Support",
    hi:"सहायता के लिए कॉल करें"
  },
  proceedButton:{
    en:"Verify",
    hi:"आगे बढ़ें",
    or: "ଆଗକୁ ବଢ଼ନ୍ତୁ",
    mr : "पुढे जा"
  },
  verifying: {
    en: "Verifying...",
    hi: "जांच हो रही है...",
    or: "ଯାଞ୍ଚିତ କରିବା ହାରାଇଛି...",
    mr: "तपासणी सुरू आहे..."

  },
  otpTitle: {
    en: "Enter 6 digit HealthVaani code",
    hi: "6 अंकों का HealthVaani कोड दर्ज करें।",
    or: "6 ଅଙ୍କିଆ HealthVaani କୋଡ୍ ଦିଅନ୍ତୁ",
    mr : "6 अंकी HealthVaani कोड टाका"
  },
  resendOtp: {
    en: "Send OTP Again",
    hi: "फिर से ओटीपी भेजें"
  }
};

export const getOtpSentLabel = {
  first: {
    en: "Code sent via SMS to ",
    hi: "कोड ",
    or: "କୋଡ୍‌ଟି SMS ଦ୍ୱାରା ",
    mr : "कोड "
  },
  second: {
    en: "",
    hi: " पर मैसेज कर दिया है",
    or: " କୁ ପଠାଯାଇଛି",
    mr : " या क्रमांकावर संदेशाद्वारे पाठवला आहे"
  }
}

export const loginErrorMap = {
  username: "User not found.",
  otp: "Incorrect OTP"
}

export const loginErrorLabels = {
  username:{
    en:"Please re-check your mobile number",
    hi:"कृपया अपना मोबाइल नंबर फिर से जांच लें",
    or: "ଆପଣଙ୍କର ମୋବାଇଲ ନମ୍ବର ପରିପ୍ରକ୍ଷେପରେ ପଠାନ୍ତୁ।",
    mr: ""
    },
  otp: {
    en:"Incorrect OTP",
    hi:"गलत ओटीपी",
    or: "ଗଲତ OTP",
    mr: ""
  }
}

export const logoutText = {
  confirmation : {
    en:"Do you want to Logout?",
    hi:"क्या आप लॉगआउट करना चाहते हैं?",
    or: "ଆପଣ କ'ଣ ଲଗଆଉଟ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି?",
    mr: "तुम्हाला लॉगआउट करायचे आहे का?"
  },
  yes:{
    en:"Yes, Log Out",
    hi:"हाँ, लॉगआउट",
    or: "ହଁ, ଲଗଆଉଟ୍",
    mr: "होय, लॉगआउट"
  },
  no:{
    en:"No, Go back",
    hi:"नहीं, चेट पर लौटें",
    or: "ନା, ଫେରି ଯାଆନ୍ତୁ",
    mr: "नाही, चॅटवर परत जा"
  }
}
export const resendOtpTimer = {
  first: {
    en: "Resend Code in ",
    hi: "कोड दोबारा भेजें",
    or: "",
    mr : "कोड पुन्हा पाठवा"
  },
  second: {
    en: " sec",
    hi: " sec",
    or: " sec ପୁନଃ କୋଡ୍ ପଠାନ୍ତୁ",
    mr : " सेकंद"
  }
}

export const resendOtpConstants = {
  first: {
    en: "Didn’t receive code?",
    hi: "कोड प्राप्त नहीं हुआ?",
    or: "କୋଡ୍ ମିଳିଲା ନାହିଁ?",
    mr : "कोड प्राप्त झाला नाही?"
  },
  second: {
    en: "Resend",
    hi: "दोबारा भेजें",
    or: "ପୁନିଥରେ ପଠାନ୍ତୁ",
    mr : "पुन्हा पाठवा"
  }
}
export const verifyingCaptcha = {
  en:"Verifying you are human...",
  hi:"आप एक मनुष्य हैं की जांच कर रहा है...",
  or: "ଆପଣ ଏକ ମାନୁଷଙ୍କ ହେଉଛନ୍ତି କିନ୍ତୁ ନାହିଁ କିନ୍ତୁ ନାହିଁ",
  mr: "आपण मानव आहात की नाही हे तपासत आहोत...",
}